import React from 'react';
import './WhyUs.css';

import { whyAttend } from '../../../constants';
import { Heading } from '../../../components';



const WhyUs = () => { 

  return (
    <section className="custom-form whyAttend">

      {/* Content Container */}
      <div className="box-container">

        <div className='content'>
          <div className='text'>

            {/* Section Heading */}
            <Heading title={whyAttend.heading} subTitle={whyAttend.sub} linear sideHeading />

            {/* Why Attend Paragraph */}
            <p>{whyAttend.content}</p>

            {/* Why Attend Points */}
            <div className="whyAttend-points">
              {whyAttend.points.map((item) => (
                <li key={item.id}>
                  <div className='icon'>{item.icon}</div>
                  <div className='text'>
                    <h5>{item.title}</h5>
                    <p>{item.content}</p>
                  </div>
                </li>
              ))}
            </div>

          </div>
        </div>

      </div>

    </section>
  );
};

export default WhyUs;